import React, {useState} from "react";
import {calculateArrows} from "./player_coordinates_calculator";
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import {useTranslation} from "react-i18next";
import ReactGA from "react-ga4";

export default function ArrowsMap(props) {
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'arrowsMap'});


    const [pathVisible, setPathVisible] = useState(false)
    const [pathSettingsVisible, setPathSettingsVisible] = useState(false)

    const [arrowsColor, setArrowsColor] = useState(localStorage.getItem("arrowscolor") || "red")
    const [arrowsWidth, setArrowsWidth] = useState(parseInt(localStorage.getItem("arrowswidth") || 3))
    const [showStepsCount, setShowStepsCount] = useState(parseInt(localStorage.getItem("arrowsshowcount") || 10000))

    function persistColor(color) {
        setArrowsColor(color)
        localStorage.setItem("arrowscolor", color)
    }

    function persistWidth(width) {
        setArrowsWidth(width)
        localStorage.setItem("arrowswidth", width)
    }

    function persistArrowsCount(count) {
        setShowStepsCount(count)
        localStorage.setItem("arrowsshowcount", count)
    }

    function switchPathVisible() {
        setPathVisible(!pathVisible)
        ReactGA.event({
                action: "click",
                category: "game field",
                label: "player path switch"
            }
        )
    }

    const reverseSteps = Array.from(props.steps).reverse()

    const stepsPositions = reverseSteps
        .filter((step) => step.type === "step")
        .filter((step) => step.to_position !== step.from_position)
        .map((step) => {
            return {
                from_position: step.from_position,
                to_position: step.to_position
            }
        })

    const cellHeight = parseInt(props.fieldStyle.cell_height)
    const cellWidth = parseInt(props.fieldStyle.cell_width)
    const tablePaddingTop = parseInt(props.fieldStyle.padding_top)
    const tablePaddingleft = parseInt(props.fieldStyle.padding_left)

    const arrows_coords = calculateArrows(stepsPositions, cellWidth, cellHeight, tablePaddingTop, tablePaddingleft)

    function draw(x1, y1, x2, y2) {
        const centerX = (x1 + x2) / 2
        const centerY = (y1 + y2) / 2
        const offSetX = 4 * (x1 + y2 + x2 + y2) % 10 - 20; // fake random number offset
        const offSetY = 4 * (x1 + y2 + x2 + y2) % 10 - 20; // fake random number offset
        return <path
            d={`M ${x1} ${y1} Q ${centerX + offSetX} ${centerY + offSetY} ${x2} ${y2}`}
            stroke={arrowsColor}
            strokeDasharray="5,2"
            strokeWidth={`${arrowsWidth}px`}
            markerEnd="url(#arrowhead)"
            markerStart="url(#arrowStart)"
            fill="transparent"
        />
    }

    function getArrowHeadWidth(arrowWidth) {
        switch (arrowWidth) {
            case 1: return 5
            case 2: return 4
            case 3: return 3
            default: return 3
        }
    }

    return <>
        <div>

        </div>
        {pathVisible &&
            <svg
                height={(parseInt(props.fieldStyle.cell_height) + 3) * 8 + parseInt(props.fieldStyle.padding_top)}
                width={(parseInt(props.fieldStyle.cell_width) + 3) * 9 + parseInt(props.fieldStyle.padding_left)}
                style={{
                    position: "absolute",
                    top: props.gameFieldOffset,
                    left: 0,
                    backgroundColor: "rgba(0,0,50,0.5)",
                    boxShadow: "10px 10px 100px 10px rgba(0,0,50,0.5)"
                }}>
                <defs>
                    <marker id="arrowhead" viewBox="0 0 10 10" refX="12" refY={getArrowHeadWidth(arrowsWidth)} markerUnits="strokeWidth"
                            markerWidth={arrowsWidth === 1 ? 10 : 6} markerHeight="12" orient="auto">
                        <path d={`M 0 0 L 18 ${getArrowHeadWidth(arrowsWidth)} L 0 ${getArrowHeadWidth(arrowsWidth) * 2} z`} stroke={arrowsColor === "black"? "white":"black"} fill={arrowsColor}/>
                    </marker>
                    <marker id="arrowStart" viewBox="0 0 10 10" refX="3" refY="3" markerUnits="strokeWidth"
                            markerWidth="6" markerHeight="6" orient="auto">
                        <circle r="3" cx="3" cy="3" stroke={arrowsColor === "black"? "white":"black"} fill={arrowsColor}/>
                    </marker>
                </defs>
                {arrows_coords.slice(-1*showStepsCount).map((arrow) => {
                    const coordsStart = arrow.start
                    const coordsEnd = arrow.end
                    return draw(coordsStart.x, coordsStart.y, coordsEnd.x, coordsEnd.y)

                })}
            </svg>}
        <div
            style={{
                position: "absolute",
                left: (parseInt(props.fieldStyle.cell_width) + 3) * 9 + parseInt(props.fieldStyle.padding_left),
                top: "5px",
                padding: "3px",
                border: "1px solid white",
                borderRadius: "6px",
                zIndex:500,
                backgroundColor: "rgba(60, 75, 173, 0.7)"
            }}
        >
            <RouteOutlinedIcon
                fontSize="medium"
                onClick={switchPathVisible}
                style={{
                    cursor: "pointer",
                    borderRadius: "6px",
                    boxShadow: "inset 0px 0px 3px 1px grey",
                    backgroundColor: pathVisible ? "rgba(125, 255, 125, 0.5)" : "rgba(125, 125, 125, 0.2)",
                    color: "white"
                }}
            />
            {pathSettingsVisible && <KeyboardArrowUpOutlinedIcon
                fontSize="small"
                style={{
                    color:"lightgrey"
                }}

                onClick={() => {
                    setPathSettingsVisible(false)
                }}
            />}
            {!pathSettingsVisible && <KeyboardArrowDownOutlinedIcon
                fontSize="small"
                style={{
                    color:"lightgrey"
                }}
                onClick={() => {
                    setPathSettingsVisible(true)
                }}
            />}
            {pathSettingsVisible && <div
                style={{
                    borderRadius: "6px",
                    display: "flex",
                    flexDirection: "column",
                    width: "300px",
                    gap:"6px",
                    margin: "6px",
                }}
            >
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    border: "1px solid grey",
                    alignItems: "center",
                    padding: "6px",
                    paddingTop: "0",
                    paddingBottom: "6px",
                }}>
                    <div
                        style={{color: "white", paddingBottom: "3px"}}
                    >{t('number_steps_to_show_label')}</div>
                    <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-evenly"
                    }}>
                        <div
                            style={{
                                width: "40px",
                                border: showStepsCount === 10 ? "3px solid white" : "1px solid grey",
                                fontWeight: showStepsCount === 10 ? "bold" : "regular",
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "white"
                            }}
                            onClick={() => {persistArrowsCount(10)}}
                        >10</div>
                        <div
                            style={{
                                width: "40px",
                                border: showStepsCount === 20 ? "3px solid white" : "1px solid grey",
                                fontWeight: showStepsCount === 20 ? "bold" : "regular",
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "white"
                            }}
                            onClick={() => {persistArrowsCount(20)}}
                        >20</div>
                        <div
                            style={{
                                width: "40px",
                                border: showStepsCount === 30 ? "3px solid white" : "1px solid grey",
                                fontWeight: showStepsCount === 30 ? "bold" : "regular",
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "white"
                            }}
                            onClick={() => {persistArrowsCount(30)}}
                        >30</div>
                        <div
                            style={{
                                width: "40px",
                                border: showStepsCount === 10000 ? "3px solid white" : "1px solid grey",
                                fontWeight: showStepsCount === 10000 ? "bold" : "regular",
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "white"
                            }}
                            onClick={() => {persistArrowsCount(10000)}}
                        >Всі</div>
                    </div>
                </div>
                {/*// --------*/}
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    border: "1px solid grey",
                    alignItems: "center",
                    padding: "6px",
                    paddingTop: "0",
                    paddingBottom: "6px",
                }}>
                    <div
                        style={{color: "white", paddingBottom: "3px"}}
                    >{t('arrows_color_label')}</div>
                    <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-evenly"
                    }}>
                        <div
                            style={{
                                width: "40px",
                                height:"30px",
                                border: arrowsColor === "white" ? "3px solid black" : "1px solid grey",
                                borderRadius: "3px",
                                cursor: "pointer",
                                backgroundColor:"white"
                            }}
                            onClick={() => {persistColor("white")}}
                        ></div>
                        <div
                            style={{
                                width: "40px",
                                height:"30px",
                                border: arrowsColor === "red" ? "3px solid white" : "1px solid grey",
                                borderRadius: "3px",
                                cursor: "pointer",
                                backgroundColor:"red"
                            }}
                            onClick={() => {persistColor("red")}}
                        ></div>
                        <div
                            style={{
                                width: "40px",
                                height:"30px",
                                border: arrowsColor === "green" ? "3px solid white" : "1px solid grey",
                                borderRadius: "3px",
                                cursor: "pointer",
                                backgroundColor:"green"
                            }}
                            onClick={() => {persistColor("green")}}
                        ></div>
                        <div
                            style={{
                                width: "40px",
                                height:"30px",
                                border: arrowsColor === "blue" ? "3px solid white" : "1px solid grey",
                                borderRadius: "3px",
                                cursor: "pointer",
                                backgroundColor:"blue"
                            }}
                            onClick={() => {persistColor("blue")}}
                        ></div>
                        <div
                            style={{
                                width: "40px",
                                height:"30px",
                                border: arrowsColor === "black" ? "3px solid white" : "1px solid grey",
                                borderRadius: "3px",
                                cursor: "pointer",
                                backgroundColor:"black"
                            }}
                            onClick={() => {persistColor("black")}}
                        ></div>
                    </div>
                </div>

                {/*-----*/}
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    border: "1px solid grey",
                    alignItems: "center",
                    padding: "6px",
                    paddingTop: "0",
                    paddingBottom: "6px",
                }}>
                    <div
                        style={{color: "white", paddingBottom: "3px"}}
                    >{t('arrows_width_label')}</div>
                    <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-evenly"
                    }}>
                        <div
                            style={{
                                width: "40px",
                                border: arrowsWidth === 1 ? "3px solid white" : "1px solid grey",
                                fontWeight: arrowsWidth === 1 ? "bold" : "regular",
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "white"
                            }}
                            onClick={() => {persistWidth(1)}}
                        >1</div>
                        <div
                            style={{
                                width: "40px",
                                border: arrowsWidth === 2 ? "3px solid white" : "1px solid grey",
                                fontWeight: arrowsWidth === 2 ? "bold" : "regular",
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "white"
                            }}
                            onClick={() => {persistWidth(2)}}
                        >2</div>
                        <div
                            style={{
                                width: "40px",
                                border: arrowsWidth === 3 ? "3px solid white" : "1px solid grey",
                                fontWeight: arrowsWidth === 3 ? "bold" : "regular",
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "white"
                            }}
                            onClick={() => {persistWidth(3)}}
                        >3</div>

                    </div>
                </div>
                <div style={{width: "100%", display:"flex", justifyContent:"center"}}>
                    <div
                        style={{
                            width: "110px",
                            backgroundColor: "#59619B",
                            border: "1px outset buttonborder" ,
                            display: "flex",
                            justifyContent: "center",
                            borderRadius: "10px",
                            cursor: "pointer",
                            color: "white",
                            padding: "10px",
                            fontSize: "large"

                        }}
                        onClick={switchPathVisible}
                    >
                        {pathVisible ? t('switch_off_label') : t('switch_on_label')}
                    </div>
                </div>


            </div>}

        </div>
    </>
}